import React, { useState, useEffect, Fragment } from "react";
import Config from "../../Config";


import InputDate from "../../helpers/InputDate";
import InputText from "../../helpers/InputText";
import InputBankAccount from "../../helpers/InputBankAccount";
import InputCombo from "../../helpers/InputCombo";
import { tab } from "@testing-library/user-event/dist/tab";
import FormatDecimal from "../../helpers/FormatDecimal";


function InvoiceKSeF(props)
{

    
    
    const [view, setView] = useState('btn');
 
    const [row, setRow] = useState( props.selected );
    const [isStarted, setIsStarted] = useState(0);
    const [isClosable, setIsCloseable] = useState(1);

 

    const checkStatus = () => {
  
        var h = document.getElementById('ksef_dlg');

        if(h == undefined || h == null) return;


        props.mainView.showProgress();

         var req = {
            faktury: row,
        };



        fetch( Config.master + '/rest_v1_calc,ksef_status', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                 

                    props.mainView.hideProgress();      
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "error" ,  (resp) => { closeDlg(); });  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "error" , (resp) => { closeDlg(); } );  
                    }else    
                    {

                        
                        if(res.status == 'OK') // 
                        {
                           var goRefresh = false;

                            for(var k=0; k< res.result.length; k++)    
                            {
                                    var f_Id = res.result[k].id;
                                    var f_ksef_numer= res.result[k].ksef_numer;
                                    var f_ksef_status= res.result[k].ksef_status;

                                  

                                    for(var w=0; w<row.length; w++)
                                    {
                                        if(row[w].id == f_Id)
                                        {
                                            if(f_ksef_numer.length > 10 && row[w].status != 4)
                                            {
                                               row[w].status = 4; 
                                               row[w].ksef_numer = f_ksef_numer;
                                               row[w].ksef_status = f_ksef_status;

                                               goRefresh = true;                                                
                                            }

                                            break;
                                        }
                                    }


                            }

                            console.log("Ksef", res.result);

                            if(goRefresh)
                            {
                              setRow(JSON.parse(JSON.stringify(row)));
                              if(props.onSuccess != undefined) props.onSuccess();
                            }

                            setTimeout( ()=>{
                                checkStatus();
                            } ,1000);

                           
 
                        }else
                        {
                            props.mainView.showDialog( "Błąd",  'Spróbuj ponownie za chwilę.' , "error" ,  (resp) => { closeDlg(); });    
                        }
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "error" ,  (resp) => { closeDlg(); } );
                   props.mainView.hideProgress();
         });
                   

         return false;

    }


    



 


 const startSendProcess = async (idFaktury) => {

        
        props.mainView.showProgress();
      

        var req = {
            faktury: row,
        };
 
       
        
         fetch( Config.master + '/rest_v1_calc,invoice_send_ksef', {
            method: 'POST', 
            body: JSON.stringify(req), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_fak_sprzedawcy_id_': props.userData.fak_sprzedawcy_id,   
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                 

                    props.mainView.hideProgress();      
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "error" ,  (resp) => { closeDlg(); });  
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "error" , (resp) => { closeDlg(); } );  
                    }else    
                    {
 
                        if(res.status == 'OK') //zatwierdzono prawidlowo.. mozna wystawiac kolejny..
                        {
                        
                                for(var k=0;k<row.length; k++)
                                {
                                    row[k].status = 2; //dodano do kolejki..
                                }
                                setRow( JSON.parse( JSON.stringify(row) ) );
                                setIsCloseable(1);  
                                props.mainView.showDialog( "Sukces", "Trwa wysyłka faktur do KSeF. Jeśli chcesz możesz czekać na zakończenie procesu lub zamknąć to okno.", "ok" , (resp) => { } );  

                                checkStatus();
                        }else
                        {
                            props.mainView.showDialog( "Błąd",  'Spróbuj ponownie za chwilę.' , "error" ,  (resp) => { closeDlg(); });    
                        }
                    }
         } )
         .catch(err => {          
                    props.mainView.showDialog( "Error", "I: " + err , "error" ,  (resp) => { closeDlg(); } );
                   props.mainView.hideProgress();
         });
                   

         return false;


    }



    const startX = () => {

        if(isStarted == 1) return;

        for(var k=0;k<row.length; k++)
          {
              row[k].status = 1; 
          }
          setRow( JSON.parse( JSON.stringify(row) ) );

        setIsStarted(1);
        setIsCloseable(0);      
        startSendProcess();
    }
    

 

    const showDlg = () => {
    
         setView("dlg");   
    }     

    const closeDlg = () => {
        setView("btn");  
        setIsStarted(0); 
   }  
 
   


    if(row == null)
    {
        setRow([]); 
        return <span>...</span>
    }


    var progress = null;
    var gotowych = 0;

    for(var k=0;k<row.length; k++)
        {
            if(row[k].status == 4) //oczekuje..
            {
                gotowych++;
            }
        }

    var proc =  parseInt( (100 * gotowych) / row.length);
    
    if(gotowych > 0) 
    {
        progress = <div><strong>Postęp {proc} % </strong></div>;
    }

    



    if(row.length != props.selected.length)
    {
        setRow(props.selected);
    }



    var dlg_view =  (

            <div className="dlg_window dlg_type_x shadowx" id="ksef_dlg">

                    <div className="dlg_title">
                        Wysyłka faktur do KSeF
                    </div>


                    <div className="dlg_content_x">


                                   

                                  

                                    <br/>

                                    <div className="form_tab">

                                    <div>
                                        Gotowych do wysłania: {row.length} 
                                    </div>

                                    {progress}
 
                                    <div className="bg_center scroll150 nostick">                                            

                                            <table className="table" >
                                                    <thead>
                                                    <tr className="header">                                                                                  
                                                        <td className="td_left">LP</td>                                                                                                                                
                                                        <td>Numer</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td>Data wyst.</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td>Do zapłaty</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                        <td className="td_right">Status</td>                                                                                                                                                                                                                                                                                                                                                                                                                                        
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        row.map( (item, ix) => {

                                                            var st = item.status;
                                                            if(item.status == 0 || item.status == undefined ) st = "---";
                                                            if(item.status == 1) st = "Czekaj...";
                                                            if(item.status == 2) st = "Dodano do kolejki...";
                                                            if(item.status == 3) st = "Błąd!";
                                                            if(item.status == 4) st = "Dostarczono";

                                                            return <tr>
                                                                <td className="gocenter">{ix+1}</td>                                                                                                                                
                                                                <td className="gocenter">{item.numer_dokumentu}</td>                                                                                                                                                                                                                                        
                                                                <td className="gocenter">{item.data_wystawienia}</td>                                                                                                                                                                                                                                        
                                                                <td className="goright"> <FormatDecimal value={item.do_zaplaty} /> </td>                                                                                                                                                                                                                                        
                                                                <td className="gocenter" >{st}</td>  
                                                            </tr>
                                                        })

                                                    }
                                                </tbody>
                                            </table>

                                        </div>
  

                                        <div className="form_split"></div>
                                        <br/>
                                        <div className="form_split"></div>

                                        <div className="form_control">      
                                            {
                                                isStarted == 0 &&
                                                <Fragment>
                                                    
                                                     <div className="btn" onClick={startX}>wyślij dokumenty</div>                                                  
                                                </Fragment>                                                
                                            }                                                                                  
                                            &nbsp; &nbsp;
                                            {
                                                (isClosable == 1 || row.length == 0 ) &&
                                                <div className="btn" onClick={closeDlg}>zamknij</div>
                                            }  

                                                                                  
                                        </div>

                                       
                                        </div>

                    </div>

                
            </div>
    );

    if(view == 'btn') dlg_view = null;

    

    return  <React.Fragment>
                <div className="btn"  style={{backgroundColor: '#F00'}}  onClick={showDlg} >Wyślij do KSeF</div> 
                {dlg_view} 
           </React.Fragment>
}


export default InvoiceKSeF;